import type { StatusType } from './Field';

export enum PUBLISH_SCOPE {
    SITE = 'SITE',
    PAGE = 'PAGE'
}

export enum PublishProjectScope {
    All = 'all',
    Content = 'content'
}

export type StagedChange = {
    changeId: string;
    isStaged: boolean;
    filepath?: string;
    changeType: 'content' | 'asset' | 'schema';
    label: string;
    updatedBy: string[]; // todo: research best name for this: what cms use?
    updatedAt?: string;
    status: StatusType;
    srcObjectId: string;
    srcModelName?: string;
    srcProjectId: string;
    srcEnvironment?: string;
    srcType: string;
    locale?: string;
};
